<template>
  <v-container grid-list-md>
    <pi-progress v-if="progress" main></pi-progress>
    <pi-navigation :navigation="navigation"></pi-navigation>

    <v-layout row wrap v-if="isGroup">
      <v-flex xl3 lg4 sm6>
        <pi-groupcard :group="group" minimal>
          <v-menu bottom left v-if="Auth.check(Permissions['GROUP_EDIT'])">
            <v-btn icon slot="activator">
              <v-icon>more_horiz</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile
                v-if="Auth.check(Permissions['GROUP_EDIT'])"
                :to="`/group/${group.id}/edit`"
              >
                <v-list-tile-title>Edytuj</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </pi-groupcard>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex v-for="user in users" :key="user.id" xl3 lg4 sm6>
        <pi-usercard :user="user">
          <v-menu
            bottom
            left
            v-if="Auth.check(Permissions['USER_DELETE']) || Auth.check(Permissions['USER_EDIT'])"
          >
            <v-btn icon slot="activator">
              <v-icon>more_horiz</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile
                v-if="Auth.check(Permissions['GROUP_CHANGE'])"
                @click="showChangeGroupDialog(user)"
              >
                <v-list-tile-title>Zmień grupy</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                v-if="Auth.userData.superadmin"
                :to="Auth.userData.id == user.id ? '/user/edit' : `/user/${user.id}/edit`"
              >
                <v-list-tile-title>Edytuj</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                v-if="Auth.check(Permissions['USER_DELETE'])"
                @click="showDeleteDialog(user)"
              >
                <v-list-tile-title>Usuń</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </pi-usercard>
      </v-flex>
    </v-layout>

    <v-btn
      color="accent"
      dark
      bottom
      right
      fab
      fixed
      @click="showCreateDialog()"
      v-if="Auth.check(Permissions['USER_ADD'])"
    >
      <v-icon>add</v-icon>
    </v-btn>

    <pi-dialog
      :dialog="deleteDialog.on"
      :progress="deleteDialog.progress"
      headline="Usuwanie użytkownika"
      operation="Usuń"
      @closed="showDeleteDialog(null)"
      @action="deleteData()"
    >
      Czy chcesz usunąć użytkownika
      <b>{{deleteDialog.obj.name}} {{deleteDialog.obj.surname}}</b> z projektu?
    </pi-dialog>

    <pi-dialog
      :dialog="changeGroupDialog.on"
      :progress="changeGroupDialog.progress"
      headline="Zmiana grup"
      operation="Zmień"
      @closed="showChangeGroupDialog(null)"
      @action="changeGroup()"
    >
      <v-select
        v-model="changeGroupDialog.groupsSelected"
        :items="changeGroupDialog.groups"
        item-text="name"
        item-value="id"
        attach
        chips
        label="Należy do"
        multiple
      ></v-select>
    </pi-dialog>

    <pi-dialog
      :dialog="createDialog.on"
      :progress="createDialog.progress"
      headline="Dodawanie użytkownika"
      operation="Dodaj"
      @closed="showCreateDialog(false)"
      @action="createUser()"
    >
      <v-form ref="logForm" @submit.prevent lazy-validation>
        <v-text-field
          v-model="createDialog.email"
          :rules="Rules.user.email"
          required
          prepend-icon="mail"
          name="email"
          label="Email"
        ></v-text-field>
      </v-form>
    </pi-dialog>

    <pi-snackbar :color="snackbar.color" :snackbar.sync="snackbar.on" :message="snackbar.message"></pi-snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    progress: false,
    snackbar: { on: false, color: "error", message: "" },
    fab: false,
    users: [],
    group: {},
    navigation: [],
    deleteDialog: { on: false, obj: {}, progress: false },
    changeGroupDialog: {
      on: false,
      obj: {},
      progress: false,
      groups: [],
      groupsSelected: [],
      groupsFetched: false
    },
    createDialog: {
      on: false,
      progress: false,
      email: ""
    }
  }),
  computed: {
    basicUrl() {
      const group = this.isGroup ? `/group/${this.groupId}` : "";
      return `/users${group}`;
    },
    groupId() {
      return this.$route.params.groupId;
    }
  },
  props: { isGroup: Boolean },
  methods: {
    async getData() {
      this.progress = true;
      const response = await this.Api.send("get", this.basicUrl);
      this.progress = false;
      if (response.status) {
        if (this.isGroup) {
          this.group = response.group;
          this.users = response.group.Users;
        } else {
          this.users = response.users;
        }
        return;
      }
      this.showError(response.message);
    },
    async createNavigation() {
      this.navigation = [{ id: 0, text: "Użytkownicy", href: "/user/all", disabled: !this.isGroup }];
      if (this.isGroup)
        this.navigation.push({
          id: 1,
          text: this.group.name,
          href: `/user/group/${this.group.id}`,
          disabled: true
        });
    },
    async showDeleteDialog(obj) {
      this.deleteDialog.obj = obj ? obj : {};
      this.deleteDialog.on = !!obj;
    },
    async deleteData() {
      this.deleteDialog.progress = true;
      const response = await this.Api.send(
        "delete",
        `/users/${this.deleteDialog.obj.id}`
      );
      this.deleteDialog.progress = false;
      if (response.status) {
        this.showDeleteDialog(null);
        this.showSuccess("Użytkownik usunięty");
        this.getData();
        return;
      }
      this.showDeleteDialog(null);
      this.showError(response.message);
    },
    async showChangeGroupDialog(obj) {
      this.changeGroupDialog.obj = obj ? obj : {};
      this.changeGroupDialog.on = !!obj;
      if (!this.changeGroupDialog.on) return;
      this.changeGroupDialog.groupsSelected = obj.Groups.map(g => g.id);
      if (!this.changeGroupDialog.groupsFetched) await this.getGroupData();
    },
    async getGroupData() {
      if (!this.Auth.userData.superadmin) {
        this.changeGroupDialog.groups = this.Auth.userData.Groups.slice();
        this.changeGroupDialog.groupsFetched = true;
        return;
      }
      this.changeGroupDialog.progress = true;
      const response = await this.Api.send("get", "/groups");
      this.changeGroupDialog.progress = false;
      if (response.status) {
        this.changeGroupDialog.groups = response.groups;
        this.changeGroupDialog.groupsFetched = true;
        return;
      }
      this.changeGroupDialog.groups = {};
      this.showError(response.message);
    },
    async changeGroup() {
      const data = this.changeGroupDialog.groups.map(g => {
        return {
          id: g.id,
          add: this.changeGroupDialog.groupsSelected.includes(g.id)
        };
      });
      this.changeGroupDialog.progress = true;
      const response = await this.Api.send(
        "put",
        `/users/change/${this.changeGroupDialog.obj.id}`,
        {
          change: data
        }
      );
      this.changeGroupDialog.progress = false;
      if (response.status) {
        this.showChangeGroupDialog(null);
        this.showSuccess("Grupy zmienione");
        this.getData();
        return;
      }
      this.showChangeGroupDialog(null);
      this.showError(response.message);
    },
    async showCreateDialog(show = true) {
      if (!show) {
        return (this.createDialog.on = false);
      }
      this.createDialog.email = "";
      this.createDialog.on = true;
    },
    async createUser() {
      if (!this.$refs.logForm.validate()) {
        return this.showError("Uzupełnij wymagane pola");
      }
      this.createDialog.progress = true;
      const response = await this.Api.send(
        "get",
        `/users/check/${this.createDialog.email}`
      );
      this.createDialog.progress = false;
      if (response.status) {
        if (response.exists) {
          this.createDialog.progress = true;
          const response = await this.Api.send("post", "/users/project", {
            email: this.createDialog.email
          });
          this.createDialog.progress = false;
          if (response.status) {
            this.showCreateDialog(false);
            this.showSuccess("Użytkownik dodany do projektu");
            this.getData();
            return;
          }
          this.showCreateDialog(false);
          this.showError(response.message);
        } else {
          this.$router.push(`/user/create/${this.createDialog.email}`);
        }
        return;
      }
      this.showCreateDialog(false);
      this.showError(response.message);
    },
    async showError(message) {
      this.snackbar.color = "error";
      this.showMessage(message);
    },
    async showSuccess(message) {
      this.snackbar.color = "success";
      this.showMessage(message);
    },
    async showMessage(message) {
      this.snackbar.message = message;
      this.snackbar.on = true;
    }
  },
  async mounted() {
    await this.getData();
    this.createNavigation();
  }
};
</script>
